module.exports = __webpack_public_path__ + "static/media/CitrusStage1.b486d4bf.PNG";